/**
 * Der Schalter „Kurz Bescheid geben, wenn die Antwort dauert“ (Warte-Brücke, server/warte-bruecke.ts).
 * (06.10.2026, Ticket 2738)
 *
 * EIN Besitzer für die Regel, die Server (spricht sie?) und Einstellungsseite
 * (was zeigt der Schalter?) gleich rechnen müssen — sonst zeigt die Seite „aus“,
 * während der Server spricht.
 *
 *   - nur Konto 1 (das Hauptkonto, wie der Anruf und das Vor-Modell);
 *   - Vorgabe AUS seit 13.10.2026 (vorher AN): nur ein ausdrückliches `true` schaltet ein.
 *
 * ⚠️ Ob die Vorgabe AN bleibt, ist offen (Prüfbefund 06.10.2026, Martin entscheidet).
 *    Sein Ja vom 06.10.2026 galt der Frage: „Soll Vespera dir gleich nach der Frage
 *    einen kurzen Satz sagen, WAS SIE GERADE TUT, auch wenn du ‚kurz‘ eingestellt
 *    hast?“ — also der Vorantwort (server/vorantwort.ts). „Einen Moment.“ sagt nicht,
 *    was sie tut, und kommt in gut jedem vierten Zug. Dagegen stehen seine Absagen an
 *    Füllsätze (03.09., 29.07.; frontend/app.ts, ZWISCHENMELDUNG_MS).
 *
 * ⚠️ Eigener Schalter, NICHT der der Vorantwort (`vorantwortBeta`): die
 *    Vorantwort nimmt einen Auftrag auf, die Brücke überbrückt nur Stille.
 *    Martin soll beide getrennt hören und abschalten können (Prüfbefund 05.10.).
 */

/** Der Schlüssel in den Einstellungen des Kontos. */
export const WARTE_SATZ_FELD = "warteSatz";

/** Nur dieses Konto bekommt den Warte-Satz (Betreiber, SUPERUSER_ID in server/werkzeug-bereiche.ts). */
const WARTE_SATZ_KONTO = 1;

/** Gilt der Schalter für dieses Konto überhaupt (und steht er darum in den Einstellungen)? Rein. */
export function warteSatzFuerKonto(userId: number | null | undefined): boolean {
  return userId === WARTE_SATZ_KONTO;
}

/**
 * Ist der Warte-Satz an? Nur Konto 1, und seit 13.10.2026 (Tickets 3184/3185) nur bei ausdrücklichem `true`:
 * „Einen Moment.“ ist genau die leere Ankündigung, die Martin nicht will. Rein.
 */
export function warteSatzAn(wert: unknown, userId: number | null | undefined): boolean {
  return warteSatzFuerKonto(userId) && wert === true;
}
